// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1X2Kx","box":"WorkspacesBox_box__DtW64","node":"WorkspacesBox_node__3NWy_"};